import React, { useContext } from 'react'

import { makeStyles } from '@material-ui/core'

import AuthContext from 'contextApi/AuthContext'

const useStyles = makeStyles(() => ({
  navBarButton: {
    padding: '10px 20px',
    borderRadius: '9999px',
    backgroundColor: 'transparent',
    border: '2px solid #fff',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s, color 0.3s, border 0.3s',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#6064DF',
      border: '2px solid #6064DF',
    },
    '@media (max-width: 959px)': {
      color: '#000000',
      border: '2px solid #000000',
    },
  },
}))

const TicketButton = () => {
  const classes = useStyles()
  const { hubspotTicketUrl } = useContext(AuthContext)

  if (!hubspotTicketUrl) return null
  return (
    <a target="_blank" rel="noreferrer" href={hubspotTicketUrl} className={classes.navBarButton}>
      Solicitar Ticket
    </a>
  )
}

export default TicketButton
